<template>
  <div :class="[isFullScreen ? 'h-full' : 'content-wrapper']" class="list-layout bg-white dark:bg-darkblue-900 flex flex-col w-full relative">
    <slot name="header" />
    <article class="content flex flex-col flex-auto overflow-y-auto">
      <div class="table-tools top-0 px-4 lg:px-10 bg-white dark:bg-darkblue-900"
        :class="!isLower1024 ? 'sticky' : ''">
        <div class="flex flex-col lg:flex-row justify-between items-center space-y-3">
          <slot name="table-core" />
        </div>
        <slot name="table-tags" />
      </div>
      <div 
        :class="[
          { 'table-actions-visible': tableTools },
          { 'overflow-hidden': !isLower1024 },
        ]" 
        class="flex-grow table-kendo">
        <!-- pb-11 lg:pb-15 <div class="w-full lg:px-9"> aqui estaba antes tab-component</div> -->
        <slot name="table-component" />
      </div>
    </article>
    <slot name="layout-extend" />
  </div>
</template>
<script>
export default {
  name: 'layout-list',
  props: {
    tableTools: {
      type: Boolean,
      default: false
    },
    isFullScreen: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isLower1024: function () {
      return this.$store.getters['app/getIsLower1024']
    },
  },
}
</script>
<style lang="scss" scoped>
.content-wrapper {
  width: 100%;
  @include breakpoint(lg) {
    width: calc(100% - 18.125rem);
  }
}

.aside-is-collapsed {
  .content-wrapper {
    @include breakpoint(lg) {
      width: calc(100% - 4.5rem);
    }
  }
}
</style>
